// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AspModal_Modal__lLm0H {
    position: fixed;
    z-index: 9999;
    background-color: white;
    width: 60%;
    border: 1px solid #ccc;
    box-shadow: 1px 1px 1px black;
    padding: 16px;
    left: 15%;
    top: 30%;
    box-sizing: border-box;
    transition: all 0.3s ease-out;
    text-align: center;
    border-radius: 5px;
}

.AspModal_CancelButtonConatiner__alTUh{
    margin-top: 15px;
}

.AspModal_CancelButton__i8c86 {
    width: 74px;
    height: 32px;
    padding: 1px 16px;
    margin-top: 15px;
    border-radius: 4px !important;
    border: solid 1px #dddbda !important;
    background-color: #ffffff !important;
    line-height: 2.31;
    text-align: center;
    color: #0070d2 !important;
    text-transform: none !important;
    margin: 0 10px !important;
}

@media (min-width: 600px) {
    .AspModal_Modal__lLm0H {
        width: 350px;
        left: calc(50% - 200px);
    }
}

.AspModal_modalHeadingTextStyle__G1vtS {
    display: flex;
    padding: 8px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/AspModal/AspModal.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa;IACb,SAAS;IACT,QAAQ;IACR,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,oCAAoC;IACpC,oCAAoC;IACpC,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI;QACI,YAAY;QACZ,uBAAuB;IAC3B;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;AAClB","sourcesContent":[".Modal {\n    position: fixed;\n    z-index: 9999;\n    background-color: white;\n    width: 60%;\n    border: 1px solid #ccc;\n    box-shadow: 1px 1px 1px black;\n    padding: 16px;\n    left: 15%;\n    top: 30%;\n    box-sizing: border-box;\n    transition: all 0.3s ease-out;\n    text-align: center;\n    border-radius: 5px;\n}\n\n.CancelButtonConatiner{\n    margin-top: 15px;\n}\n\n.CancelButton {\n    width: 74px;\n    height: 32px;\n    padding: 1px 16px;\n    margin-top: 15px;\n    border-radius: 4px !important;\n    border: solid 1px #dddbda !important;\n    background-color: #ffffff !important;\n    line-height: 2.31;\n    text-align: center;\n    color: #0070d2 !important;\n    text-transform: none !important;\n    margin: 0 10px !important;\n}\n\n@media (min-width: 600px) {\n    .Modal {\n        width: 350px;\n        left: calc(50% - 200px);\n    }\n}\n\n.modalHeadingTextStyle {\n    display: flex;\n    padding: 8px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Modal": `AspModal_Modal__lLm0H`,
	"CancelButtonConatiner": `AspModal_CancelButtonConatiner__alTUh`,
	"CancelButton": `AspModal_CancelButton__i8c86`,
	"modalHeadingTextStyle": `AspModal_modalHeadingTextStyle__G1vtS`
};
export default ___CSS_LOADER_EXPORT___;
